import Error from "components/form/Error";
import InputAreaPrice from "components/form/InputAreaPrice";
import LabelArea from "components/form/LabelArea";
import React from "react";

const DynamicPermitInput = ({ dataInput, register, errors, handleChange }) => {
  return (
    <div>
      {/* Column Headers - only once */}
      <div className="grid grid-cols-12 gap-x-3 mb-2">
        <div className="col-span-4">
          <LabelArea label="Vehicle Type" required />
        </div>

        <div className="col-span-4">
          <LabelArea label="Permit" required />
        </div>
      </div>

      {/* Vehicle Rows */}
      {dataInput.map((val, i) => (
        <div
          className="grid grid-cols-12 gap-x-3 gap-y-7 mb-5 items-center"
          key={i}
        >
          {/* Vehicle Type */}
          <div className="col-span-4 relative">
            <input
              type="text"
              value={val[`vehicle_type_name_${i}`] || ""}
              disabled
              className="border h-10 text-sm block w-full bg-gray-100 rounded-md px-3 "
            />

            <Error errorName={errors[`vehicle_type_names_${i}`]} />
          </div>

          {/* Permit */}
          <div className="col-span-4 relative">
            <InputAreaPrice
              register={register}
              name={`permit_${i}`}
              label="Permit"
              type="number"
              maxLength={6}
              value={val[`permit_${i}`] ?? "0"}
              onChangeFunction={(e) => handleChange(e, i)}
              placeholder="Permit"
              required={true}
            />

            <Error errorName={errors[`permit_${i}`]} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default DynamicPermitInput;
